import type * as React from 'react';
import { get } from '@Domain/Api';
import invitationFetched, {
	type InvitationFetchedAction,
	type InvitationPayload,
} from '@Application/Security/Invitations/Actions/invitationFetched';
import invitationFetchFailed, {
	type InvitationFetchFailedAction,
} from '@Application/Security/Invitations/Actions/invitationFetchFailed';
import type FetchInvitation from '@Application/Security/Invitations/Queries/FetchInvitation';
import FALLBACK_MESSAGES from '@Application/Security/TokenJourney/FALLBACK_MESSAGES';
import resolveFailureReason from '@Application/Security/TokenJourney/resolveFailureReason';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = InvitationFetchedAction | InvitationFetchFailedAction;

export default (query: FetchInvitation) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Public, token-carried route: there is no session to refresh on a 401.
			const payload = await get<InvitationPayload>(
				`${parameters.api.host}/api/invitations/${query.token}`,
				{
					retryOnUnauthorized: false,
				},
			);

			const action = invitationFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const extractedMessages = extractMessages(error);
			const reason = resolveFailureReason(error);
			const message = extractedMessages?.message ?? FALLBACK_MESSAGES.invitationGone;
			const action = invitationFetchFailed(extractedMessages, reason, message);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
